import React from "react";
import Layout from "../components/Layout";
import { graphql } from "gatsby";
import Testimonials from "../components/Testimonials";

const Blog = ({
                data: {
                  allStrapiTestimonials: {
                    nodes: testimonials
                  }
                }
              }) => {
  return <Layout>
    <section className="blog-page">
      <Testimonials testimonials={testimonials} title="testimonials " />
    </section>
  </Layout>;
};

export const query = graphql`
  {
    allStrapiTestimonials {
      nodes {
        Name
        company
        testimony
        id
        image {
          childImageSharp {
            fluid {
                            ...GatsbyImageSharpFluid

            }
          }
        }
      }
    }
  }
`;
export default Blog;
